import { render, staticRenderFns } from "./doctorEdit.vue?vue&type=template&id=fa154c9e&"
import script from "./doctorEdit.vue?vue&type=script&lang=js&"
export * from "./doctorEdit.vue?vue&type=script&lang=js&"
import style0 from "./doctorEdit.vue?vue&type=style&index=0&id=fa154c9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports